import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatDialogRef, MatDialog, MatPaginator, MatSort, PageEvent } from '@angular/material';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';

import { PaginationModel } from 'src/app/models/shared-models';
import { SharedService } from 'src/app/services/shared.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss']
})
export class EventsListComponent implements OnInit {

  loading = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['venue', 'date', 'closingDate', 'courseDesigners', 'startingTime', 'schedule'];
  lookupTimerForSearh = null;
  searchText: string = '';
  length: number;
  dataSource: MatTableDataSource<Event>;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  userRole: string;
  constructor( private sharedService: SharedService, private authService : AuthenticationService,
    private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit() {
    this.userRole = this.authService.getUserRole();
    this.dataSource = new MatTableDataSource<Event>();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.loading = false;
    this.GetData(new PaginationModel(1, 15, this.searchText, this.sort.active, this.sort.direction));
  }

  onAdd() {
    this.router.navigate(['./', -1], { relativeTo: this.route });
  }

  onEdit(eventId: number) {
    if (this.userRole === "Administrator")
      this.router.navigate(['./', eventId], { relativeTo: this.route });
  }

  private GetData(pagination: PaginationModel) {
    this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.sharedService.GetEvents(pagination).subscribe(result => {
      this.dialogRef.close();
      this.length = result.count;
      this.dataSource = new MatTableDataSource<Event>(result.data);
      this.dataSource.sort = this.sort;
    }, error => {
      this.dialogRef.close();
    });
  }

  onPageChange(value: PageEvent) {
    this.GetData(new PaginationModel(value.pageIndex + 1, value.pageSize, this.searchText, this.sort.active, this.sort.direction));
  }

  onSearchChange(event: any) {
    this.searchText = event;
    clearTimeout(this.lookupTimerForSearh);
    this.lookupTimerForSearh = setTimeout(() => {
      this.GetData(new PaginationModel(1, this.paginator.pageSize, this.searchText, this.sort.active, this.sort.direction))
    }, 1000);
  }

  onDownloadChamp(){
    window.open("/assets/2023 July Championship Program.pdf", "_blank");
  }
  
  onDownloadStable(){
    window.open("/assets/July 2023 show stable layout.pdf", "_blank");
  }

  download(evt) {
    this.sharedService.EventDownload(evt.id).subscribe(result => {
      const mediaType = evt.uploadType;
      const blob = new Blob([result], { type: mediaType });
      const filename = evt.uploadName;
      saveAs(blob, filename);
      window.open(filename);
    });
  }

  onRegister(evt) {
    this.router.navigate(['/events/register/' + evt.id + "/-1"]);
  }
}
